import React from "react";

import { Button } from "antd";

export default function NameAndPhone({
  showEdit,
  name,
  phone,
  profile,
  handleTextChange,
  handleSaveCancelClick,
  handleSaveEditClick,
  handleEditClick,
  loading,
}) {
  if (showEdit) {
    return (
      <>
        <div className="myAccountProfileInputContainer">
          <div className="myAccountFormTitle">
            name
          </div>
          <div className="my-profile-edit-name">
            <input
              type="text"
              placeholder="Name"
              className="myaccountEditInput myaccountEditInputWidth"
              defaultValue={name}
              onChange={(event) => handleTextChange(event, "name")}
            />
          </div>
          <div className="myAccountFormTitle">
            PHONE
          </div>
          <div className="my-profile-edit-phone">
            <input
              type="text"
              placeholder="Phone"
              className="myaccountEditInput myaccountEditInputWidth"
              defaultValue={phone}
              onChange={(event) => handleTextChange(event, "phone")}
            />
          </div>
        </div>
        <div className={loading ? "my-profile-cancel-submit-buttons my-profile-loading" : "my-profile-cancel-submit-buttons"}>
          <Button
            htmlType="button"
            type="default"
            onClick={() => handleSaveCancelClick()}
          >
            Cancel
          </Button>
          <Button
            htmlType="button"
            type="primary"
            onClick={() => handleSaveEditClick()}
          >
            Submit
          </Button>
        </div>
      </>
    );
  }

  return (
    <div className="myAccountProfileInputContainer">
      <div className="myAccountFormTitle">
        name
      </div>
      <input
        type="text"
        placeholder="Name"
        defaultValue={profile.name}
        className="myaccountDefaultInput my-profile-name-input-disabled"
        disabled
      />
      <div
        className="myAccountEditProfile"
        onClick={() => handleEditClick("all")}
      >
        Edit profile
      </div>
      <div className="myAccountFormTitle">
        PHONE
      </div>
      <input
        type="text"
        placeholder="Phone"
        defaultValue={profile.phone}
        className="myaccountDefaultInput"
        disabled
      />
    </div>
  );
}
